import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerResetPasswordPage from "@/pages/partner/PartnerResetPasswordPage";
export const Route = createFileRoute("/partner_/reset-password")({
  head: () =>
    pageHead(
      "Partner Reset-Password",
      "Secure Partner account access.",
      "/partner/reset-password",
      true,
    ),
  component: PartnerResetPasswordPage,
});
